import { Link } from "react-router-dom";
import { RoomsNav, usePageMeta } from "@/lib/site";

export default function Home() {
  usePageMeta("MAATTR", "");
  return (
    <div className="home" data-testid="home">
      <div className="door">
        <header className="name fade">MAATTR</header>
        <main>
          <h1 className="line" data-testid="home-line">
            <span className="first fade">The layer you sense is&nbsp;missing</span>
            <Link className="is fade" to="/work-with" aria-label="is. Work with MAATTR" data-testid="home-is-link">is.</Link>
          </h1>
        </main>
      </div>
      <div className="below"><RoomsNav /></div>
    </div>
  );
}
